import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeCollection } from '~data/selectors/collections';
import HexToHsl from '~modules/format/color/hextToHsl';

const emptyObj = {};

export default function CollectionAccentColor({ _id, children, force }) {
  const getCollection = useMemo(() => makeCollection(), []);
  const color = useSelector((state) => getCollection(state, _id).color);
  const theme = useSelector((state) => state.local.theme);

  let hsl = '';
  try {
    hsl = HexToHsl(color);
  } catch (e) {}

  return children(
    (!force && theme.app == 'night') || !color
      ? emptyObj
      : {
          '--accent-color': color,
          '--accent-hsl': hsl,
        },
  );
}
